import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';

import { SettingsService } from 'app/_services/settings.service';
import { BaseService } from 'app/_services/base.service';
import { AccountService } from 'app/account/account.service';

declare const isEmpty: any;

@Injectable({ providedIn: 'root' })
export class BuyerDadosPedidoService extends BaseService {
    private _domain: string = '/buyer/orders';

    constructor(private accountService: AccountService, private config: SettingsService) {
        super();
    }

    public addOrderComplement(order_id: number, answer_in_id: number, peca: any): Observable<any> {
        const body = { order_id, answer_in_id, peca };
        return this.config.executePost({ url: `${this._domain}/add-complement`, body });
    }

    public changeOrderDeliveryDate(orderId: number, confirmation_date: Date, is_bo: boolean, is_pf: boolean, items_id: any, delivery_date?: Date): Observable<any> {
        const body = { confirmation_date, delivery_date, is_bo, is_pf, items_id };
        return this.config.executePut({ url: `${this._domain}/${orderId}/change-delivery-date`, body });
    }

    public changeOrderFrete(orderId: any, frete: any): Observable<any> {
        const body = {
            answer_in_id: frete.answer_in_id,
            shipping_cost: frete.shipping_cost,
            buyer_responsability: frete.buyer_responsability,
            was_changed: frete.was_changed
        };

        return this.config.executePut({ url: `${this._domain}/${orderId}/change-shipping`, body });
    }

    public changeOrderValues(orderId: number, itemId: number, quantity: number, discount: number, discount_original: number, value: number): Observable<any> {
        const body = { quantity, discount, discount_original, value };
        return this.config.executePut({ url: `${this._domain}/${orderId}/change-values/${itemId}`, body });
    }

    public changeOrder(order_id: number, lista_pecas: any, frete: any): Observable<any> {
        const body = { order_id, lista_pecas, frete };
        return this.config.executePut({ url: `${this._domain}/${order_id}/change`, body });
    }

    public get(quotation_id: number): Observable<any> {
        const url = `${this._domain}/quotation/${quotation_id}`;

        return this.config.executeGet({ url });
    }

    public getRejectOrderReasons(cancelReasonRelatedId: number): Observable<any> {
        return this.config.executeGet({ url: `${this._domain}/rejected-order-reasons/${cancelReasonRelatedId}` });
    }

    public markItemAsSolved(itemId: number, orderId: number): Observable<any> {
        return this.config.executePost({ url: `${this._domain}/${orderId}/item/${itemId}/mark-as-solved`, body: {} });
    }

    public setPartsAsDelivered(order_id: number, item_ids: number[])
    {
        const body = { item_ids };
        return this.config.executePost({ url: `${this._domain}/${order_id}/parts/delivered`, body });
    }

    public setPartsAsRejected(order_id: number, reopen: boolean, item_ids: number[], reason_id: number = null, comment: string = null)
    {
        const body = { comment, item_ids, reason_id, reopen };
        return this.config.executePost({ url: `${this._domain}/${order_id}/parts/rejected`, body });
    }

    public trocarDevolver(opcao: number, order_id: number, lista_item_ids: number[], motivo: string): Observable<any> {
        const body = { opcao, order_id, lista_item_ids, motivo };
        return this.config.executePost({ url: `${this._domain}/trocar-devolver`, body });
    }
}
